import { injectable } from "inversify";
import * as React from "react";
import clubcardOpenImageHu from "../assets/images/omona_vipcard_show.png";
import clubcardOpenImageEn from "../assets/images/omona_vipcard_show_en.png";
import { get } from "lodash-es";

const translations = {
  hu: {
    upcomingEvents: <>Közelgő események</>,
    reserveNotice: (
      <>
        A jegyfoglalás kizárólag Facebook loginnal lehetséges!
        <br />
        <br />
        Amennyiben egyszer elfogadtad az Omona FB logint, onnantól bármikor tudsz foglalni jegyet az eseményekre újabb
        elfogadás nélkül
      </>
    ),
    okay: <>Okés</>,
    reserve: <>Foglalás</>,
    continueWithFacebook: <>Folytatás a Facebookkal</>,
    canceledFacebookLogin: <>El kell fogadnod az Omona FB logit, mielőtt jegyet tudnál foglalni.</>,
    enterEmail: <>Kérjük add meg az emailed a folytatáshoz:</>,
    acceptTerms: (
      <>
        Elolvastam és elfogadom az{" "}
        <a href="/aszf" target="_blank">
          Általános Szerződési Feltételeket
        </a>
      </>
    ),
    confirmEmail: <>Biztos erre az email címre szeretnél foglalni?<br />Ha nem jó az email címed, átírhatod!</>,
    confirmEmailClubcard: ({ name }: { name: string }) => (
      <>
        Kedves {name}!<br />
        Köszönjük a igénylési kérelmedet az OMONA CLUB CARD-hoz.
      </>
    ),
    bookingError: <>Hiba történt. Kérjük próbáld meg újra vagy írj nekünk és utánanézünk.</>,
    noTicketsLeft: <>Sajnos elfogytak a jegyek. Kérjük nézz vissza később és foglalj jegyet későbbi eseményeinkre!</>,
    alreadyBooked: <>Már foglaltál jegyet erre az eseményre. Kérjük várd meg, amíg visszajelzünk.</>,
    alreadyBookedClubcard: <>Már nyújtottál be igénylést</>,
    successLine1: (
      <>
        Megvolt az
        <br />
        első lépés
      </>
    ),
    successLine1Clubcard: ({ name }: { name: string }) => <>Köszönjük kedves {name}! Igénylésed sikeres volt!</>,
    successLine2: ({ name }: { name: string }) => <>Kedves {name}!</>,
    successLine2Clubcard: <>Kérjük nézd a postafiókodat, mert hamarosan érkezik a levél a további infókkal!</>,
    successLine3: <>Köszönjük a jegyfoglalást!</>,
    successLine3Clubcard: <>Várunk sok szeretettel következő bulinkon! Az Omona Csapata!</>,
    successLine4: <>Foglalásod még nem végleges!</>,
    successLine5: (
      <>
        Kérjük várd a facebookos email címedre érkező jóváhagyó emailt / OMONA facebook értesítést a foglalásod
        státuszáról! (Néha bekerül a spam levelek közé, ott is nézd meg!)
      </>
    ),
    successLine6: (
      <>
        Amennyiben van elérhető jegy limitált számú bulinkra nincs ok aggodalomra!
        <br />
        Alig várjuk, hogy lássunk :)
      </>
    ),
    booking: <>Jegyfoglalás</>,
    ticketTypeFull: <>Sajnos elfogytak a helyek</>,
    ticketTypeAlreadyBooked: <>Már jelentkeztél</>,
    ticketTypeBookable: <>Még van elérhető jegy</>,
    price: ({ price }: { price: number }) => <>{price}Ft</>,
    ticketTypeFull2: <>Sajna lekésted</>,
    booked: <>Jelentkezve</>,
    loading: <>Betöltés...</>,
    noEvents: <>A foglalás hamarosan kezdődik</>,
    reservationWarning: (
        <div className="general-reservation-info">
            <h3>Általános foglalási infók</h3>
            <ul>
                <li>A jegy kiválasztása utáni felüelten bármilyen email címre kérheted a jegyedet!</li>
                <li>A foglalt árú jeggyel éjfélig tudsz csak belépni az adott eseményre! (Utána helyszíni jegy váltható)</li>
                <li>A jegyek csakis 48 órával az esemény előttig mondhatóak csak le</li>
                <li>48 órával előtti lemondással kapcsolatosan Facebook üzenetet írj az Omona oldalnak (Ne emailt)</li>
                <li>Ha nem jelensz meg, vagy 48 órán belül mondod le a jegyet, Omona fiókod korlátozásra kerül</li>
            </ul>
        </div>
      // <>
      //   Kérjük csak akkor foglalj jegyet, amennyiben biztos jössz a bulira! Ha foglaltál és mégsem tudsz jönni kérünk
      //   írj oldalunknak a Facebookon lemondásoddal kapcsolatosan!
      //   <br />
      //   <b>Aki foglalt és változás esetén nem mondja le a jegyét TILTÓ LISTÁRA kerül!</b>
      // </>
    ),
    clubcardSuccessText: <>A következő bulin az alábbi kóddal tudod kikérni a kártyádat:</>,
    freemailNote: <>(A biztonság kedvéért NE freemailos vagy citromail/indamail-es címet adj meg)</>,
    reserveSuccessPageTitle: "Sikeres foglalás",
    formikMixedDefault: "Érvénytelen",
    formikMixedRequired: "Kötelező mező",
    formikStringEmail: "Érvénytelen email cím",
    formikStringMin: "Túl rövid",
    formikTerms: "Kötelező a folytatáshoz",
    clubcardRealEmailNote:
      "Kérjük, valós címet adj meg, hogy tudjunk értesíteni zártkörű és különleges eseményeinkről!",
    clubcardOpenImageUrl: clubcardOpenImageHu,
    clubcardReserveButtonLabel: (
      <>
        <div>Kártyaigénylés</div>
        <div>Facebook accountommal</div>
      </>
    ),
    clubcardSuccessPageTitle: "Clubcard igénylés sikeres",
    clubcardRequestPageTitle: "Clubcard igénylés",
    namePlaceholder: "Név",
    birthdatePlaceholder: "Születési dátum",
    emailPlaceholder: "Email cím",
    logout: "Kijelentkezés",
    passwordModal: {
      passwordIsRequired: "Jelszó megadása kötelező",
      incorrectPassword: "Nem megfelelő jelszó",
      modalTitle: "Ez egy privát rendezvény",
      modalSummary: "Kérlek add meg a jelszót a jegyek megtekintéséhez",
      inputPlaceholder: "Jelszó",
      inProgressIndicator: "Ellenőrzés...",
    },
  },
  en: {
    upcomingEvents: <>Upcoming events</>,
    reserveNotice: (
      <>
        Ticket booking is done via Facebook login.
        <br />
        <br />
        After you accepted the Omona FB login, you can book tickets for any other event without reconfirming again.
      </>
    ),
    okay: <>Okay</>,
    reserve: <>Book my ticket</>,
    continueWithFacebook: <>Continue with Facebook</>,
    canceledFacebookLogin: <>You have to accept the Omona FB login before booking tickets.</>,
    enterEmail: <>Please enter your email before continuing:</>,
    acceptTerms: (
      <>
        I have read and agree the{" "}
        <a href="/aszf" target="_blank">
          Terms and Conditions
        </a>
      </>
    ),
    confirmEmail: <>Are you sure you want to book for this email address?<br />If your email address is incorrect, you can change it!</>,
    bookingError: <>There was an error. Please try again or write to us and we'll look into it.</>,
    noTicketsLeft: (
      <>Unfortunately, there are no tickets left. Please check back later and book a ticket to our upcoming events!</>
    ),
    alreadyBooked: <>You already booked a ticket for this event. Please wait for our confirmation.</>,
    successLine1: (
      <>
        You've made the
        <br />
        first step
      </>
    ),
    successLine2: ({ name }: { name: string }) => <>Dear {name}!</>,
    successLine3: <>Thank you for booking!</>,
    successLine4: <>Your booking is not yet final!</>,
    successLine5: (
      <>
        Please wait for a confirmation email to your facebook email address / OMONA facebook notification about your
        booking status. (Sometimes it goes in to the spam folder, also check there!)
      </>
    ),
    successLine6: (
      <>
        If there are available tickets for our limited parties, no need to fret!
        <br />
        Can't wait to see you :)
      </>
    ),
    booking: <>Booking</>,
    ticketTypeFull: <>No tickets left, sadly</>,
    ticketTypeAlreadyBooked: <>Already booked</>,
    ticketTypeBookable: <>Tickets available</>,
    price: ({ price }: { price: number }) => <>{price} HUF</>,
    ticketTypeFull2: <>Sorry, missed it</>,
    booked: <>Booked</>,
    loading: <>Loading...</>,
    noEvents: <>Booking will be soon available</>,
    reservationWarning: (
        <div className="general-reservation-info">
            <h3>General booking info</h3>
            <ul>
                <li>You can request your ticket to any email address after selecting your ticket below</li>
                <li>With the reserved price ticket, you can only enter the event until midnight! (Tickets can be purchased on the spot afterwards)
                </li>
                <li>Tickets can only be canceled up to 48 hours before the event</li>
                <li>For cancellations up to 48 hours in advance, write a Facebook message to the Omona page (No email)</li>
                <li>If you do not show up or cancel the ticket within 48 hours, your Omona account will be restricted</li>
            </ul>
        </div>
    ),
      clubcardSuccessText: <>You can ask for your card at the next party with the following code:</>,
      freemailNote: <>(DO NOT enter a freemail, citromail or indamail address as they are known to be unreliable)</>,
      reserveSuccessPageTitle: "Successful reservation",
      formikMixedDefault: "Invalid value",
      formikMixedRequired: "Required field",
      formikStringEmail: "Invalid email address",
      formikStringMin: "Too short",
      formikTerms: "Required to continue",
      clubcardRealEmailNote: "Please enter an actual address, so we can notify you of exclusive and special events!",
      clubcardOpenImageUrl: clubcardOpenImageEn,
      clubcardReserveButtonLabel: (
          <>
              <div>Request Card</div>
        <div>With my Facebook account</div>
      </>
    ),
    clubcardSuccessPageTitle: "Successful clubcard request",
    clubcardRequestPageTitle: "Clubcard request",
    namePlaceholder: "Name",
    birthdatePlaceholder: "Date of birth",
    emailPlaceholder: "Email address",
    logout: "Log out",
    passwordModal: {
      passwordIsRequired: "Password is required",
      incorrectPassword: "Incorrect password",
      modalTitle: "This is a private event",
      modalSummary: "Please enter the password to view available tickets",
      inputPlaceholder: "Password",
      inProgressIndicator: "Checking...",
    },
  },
};

type TranslationFactory = (props: Dictionary<any>) => JSX.Element;

@injectable()
export class Translate {
  private locale: "hu" | "en";

  public setLanguage(locale: "hu" | "en"): void {
    this.locale = locale;
  }

  public getLanguage(): "hu" | "en" {
    return this.locale;
  }

  public translate(key: string, props?: Dictionary<string | number>): JSX.Element | string {
    const translation: JSX.Element | TranslationFactory = get(translations[this.locale], key, "");
    return typeof translation === "function" ? translation(props || {}) : translation;
  }

  public formatLink(url: string): string {
    return `${this.locale === "en" ? "/eng" : ""}${url}`;
  }

  public choose<T>(choices: Dictionary<T>): T {
    return choices[this.locale];
  }
}
